"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonBarStyles = void 0;

var _getSpacing = require("../styleHelpers/getSpacing");

var buttonBarStyles = {
  gap: (0, _getSpacing.getSpacing)(2)
};
exports.buttonBarStyles = buttonBarStyles;